module.exports = __webpack_public_path__ + "static/media/asesmen.c45b726e.png";